import { ReactElement, ReactNode } from 'react'

/**
 * Section heading with an optional count chip, matching the Voice Agent dashboard's section titles.
 * `adornment` renders after the chip (the SMS Ops tab marks each section Live or Preview).
 */
export function SectionTitle({
  title,
  badge,
  adornment,
}: {
  title: string
  badge?: string
  adornment?: ReactNode
}): ReactElement {
  return (
    <div className="flex items-center gap-2">
      <p className="text-ui-lg text-strong">{title}</p>
      {badge !== undefined && (
        <span className="border-default ml-2 flex items-center justify-center rounded border-[0.5px] bg-gray-minimal px-1.5 py-0.5 text-label-xs text-gray-strong">
          {badge}
        </span>
      )}
      {adornment}
    </div>
  )
}
